module.exports = __webpack_public_path__ + "img/rp-kefu.d5f6c16d.png";